var _defs, _path, _polygon, _path2, _path3, _path4, _path5, _polygon2, _polygon3, _path6, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _path7, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _path8, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _path9, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _path0, _path1, _path10, _path11, _rect, _path12, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapBrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.4 425.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #a06a1a;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #e3b184;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #dba269;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #d68c38;\r\n      }\r\n\r\n      .st4 {\r\n        fill: #7d4d0c;\r\n      }\r\n\r\n      .st5 {\r\n        fill: #de975a;\r\n      }\r\n\r\n      .st6 {\r\n        fill: #e2cfbb;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.2,170.5c-5.9,0-10.6-4.7-10.6-10.6s4.7-10.6,10.6-10.6c5.9,0,10.6,4.7,10.6,10.6,0,0,0,0,0,0,0,5.8-4.7,10.6-10.6,10.6ZM62.2,151.3c-4.7,0-8.6,3.8-8.6,8.6,0,4.7,3.8,8.6,8.6,8.6,4.7,0,8.6-3.8,8.6-8.6,0,0,0,0,0,0,0-4.7-3.8-8.6-8.6-8.6Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "29.1 207.1 97.4 207.1 97.4 332.2 30.3 330.1 29.1 207.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.9,230.9c-6.3-.8-11.4-5.4-12.9-11.5-1.5,6.1-6.7,10.7-12.9,11.5,0,9.4-4.8,18.4-10.7,20.8v31.7c6,2.4,10.7,11.4,10.7,20.8,6.3.8,11.4,5.4,12.9,11.5,1.5-6.1,6.7-10.7,12.9-11.5,0-9.4,4.8-18.4,10.7-20.8v-31.7c-6-2.4-10.7-11.4-10.7-20.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.4,237.8c-5.1-.7-9.2-4.4-10.5-9.4-1.2,5-5.4,8.7-10.5,9.4,0,7.6-3.9,14.9-8.7,16.9v25.7c4.8,2,8.7,9.3,8.7,16.9,5.1.7,9.2,4.4,10.5,9.4,1.2-5,5.4-8.7,10.5-9.4,0-7.6,3.9-14.9,8.7-16.9v-25.7c-4.8-2-8.7-9.3-8.7-16.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.4,246.1c-5.1-.7-9.2-4.4-10.5-9.4-1.2,5-5.4,8.7-10.5,9.4,0,7.6-3.9,14.9-8.7,16.9v17.4c4.8,2,8.7,9.3,8.7,16.9,5.1.7,9.2,4.4,10.5,9.4,1.2-5,5.4-8.7,10.5-9.4,0-7.6,3.9-14.9,8.7-16.9v-17.4c-4.8-1.9-8.7-9.3-8.7-16.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.5,327l-60.2-1.4-.3-115.9h61.5l-.9,117.3ZM36.2,322.9l54.3,1.2.9-111.5h-55.5l.3,110.3Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "92.8 217.8 73.8 217.8 73.8 211.2 76.8 211.2 76.8 214.9 92.8 214.9 92.8 217.8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "92.4 231.3 85.6 231.3 86.3 211.1 89.3 211.2 88.7 228.4 92.4 228.4 92.4 231.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.9,229.8h-10.6v-11.2h10.6v11.2ZM77.3,227h4.6v-5.6h-4.6v5.6Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "75.8 226.1 69.2 226.1 69.2 217.8 63.9 217.8 63.9 211.2 66.9 211.2 66.9 214.9 72.2 214.9 72.2 223.3 75.8 223.3 75.8 226.1"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.6 247.8 84.2 247.8 84.2 232.1 92 232.1 92 235 87.2 235 87.2 245 91.6 245 91.6 247.8"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1 240.2 78.7 240.2 78.7 228.4 81.7 228.4 81.7 237.4 91.1 237.4 91.1 240.2"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "52.6 217.8 33.6 217.8 33.6 214.9 49.6 214.9 49.6 211.2 52.6 211.2 52.6 217.8"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.8 231.3 34 231.3 34 228.4 37.7 228.4 37.1 211.2 40.1 211.1 40.8 231.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52.1,229.8h-10.6v-11.2h10.6v11.2ZM44.5,227h4.6v-5.6h-4.6v5.6Z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "57.2 226.1 50.6 226.1 50.6 223.3 54.2 223.3 54.2 214.9 59.5 214.9 59.5 211.2 62.5 211.2 62.5 217.8 57.2 217.8 57.2 226.1"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "42.2 247.8 34.8 247.8 34.8 245 39.2 245 39.2 235 34.4 235 34.4 232.1 42.2 232.1 42.2 247.8"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "47.6 240.2 35.2 240.2 35.2 237.4 44.6 237.4 44.6 228.4 47.6 228.4 47.6 240.2"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "76.8 324.8 73.8 324.8 73.8 318.2 92.8 318.2 92.8 321 76.8 321 76.8 324.8"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "86.3 324.8 85.6 304.7 92.4 304.7 92.4 307.5 88.7 307.5 89.3 324.7 86.3 324.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.9,317.3h-10.6v-11.2h10.6v11.2ZM77.3,314.5h4.6v-5.6h-4.6v5.6Z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "66.9 324.8 63.9 324.8 63.9 318.2 69.2 318.2 69.2 309.9 75.8 309.9 75.8 312.7 72.2 312.7 72.2 321 66.9 321 66.9 324.8"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "92 303.8 84.2 303.8 84.2 288.1 91.6 288.1 91.6 291 87.2 291 87.2 301 92 301 92 303.8"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "81.7 307.5 78.7 307.5 78.7 295.7 91.1 295.7 91.1 298.6 81.7 298.6 81.7 307.5"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "52.6 324.8 49.6 324.8 49.6 321 33.6 321 33.6 318.2 52.6 318.2 52.6 324.8"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.1 324.8 37.1 324.7 37.7 307.5 34 307.5 34 304.7 40.8 304.7 40.1 324.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52.1,317.3h-10.6v-11.2h10.6v11.2ZM44.5,314.5h4.6v-5.6h-4.6v5.6Z"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "62.5 324.8 59.5 324.8 59.5 321 54.2 321 54.2 312.7 50.6 312.7 50.6 309.9 57.2 309.9 57.2 318.2 62.5 318.2 62.5 324.8"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "42.2 303.8 34.4 303.8 34.4 301 39.2 301 39.2 291 34.8 291 34.8 288.1 42.2 288.1 42.2 303.8"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "47.6 307.5 44.6 307.5 44.6 298.6 35.2 298.6 35.2 295.7 47.6 295.7 47.6 307.5"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "29.1 207.1 53.6 187.6 71.3 187.6 97.4 207.1 29.1 207.1"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "30.3 330.1 58.6 343.6 68.6 343.6 97.4 332.2 30.3 330.1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M53.2,187.6h18.2c2.5-2.1,4-5.2,4-8.5,0-6.6-5.8-11.9-13.1-11.9s-13.1,5.3-13.1,11.9c0,3.3,1.5,6.4,4,8.5Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.3,167.3c-2.4,0-4.8.6-6.9,1.8.7-.2,1.5-.3,2.2-.3,5.5,0,10,5.1,10,11.4,0,2.7-.8,5.2-2.4,7.4h6.2c2.5-2.1,4-5.2,4-8.5,0-6.6-5.8-11.9-13.1-11.9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M58.6,343.6h10c1.4,1.2,2.2,2.9,2.2,4.7,0,3.6-3.2,6.5-7.2,6.5s-7.2-2.9-7.2-6.5c0-1.8.8-3.5,2.2-4.7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.6,354.8c-1.3,0-2.6-.3-3.8-1,.4.1.8.2,1.2.2,3,0,5.5-2.8,5.5-6.3,0-1.4-.5-2.8-1.3-4h3.4c1.4,1.2,2.2,2.9,2.2,4.7,0,3.5-3.2,6.4-7.1,6.4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 61.2,
    y: 0,
    width: 2,
    height: 150.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.5,342.6c-4.7,5.4-7.3,12.3-7.4,19.4,4.9-.1,9.2-8.2,9.2-8.2,0,0,1.4,8.2,7.8,10.6,2.6-3.1,4.4-6.9,5.1-10.9,0,0-1.1,5.3,6.6,9,1.5-9.2-7.2-19.9-7.2-19.9h-14.2Z"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "31.2 207.1 48.5 207.1 44.3 198.5 31.2 207.1"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "48.5 207.1 62.9 207.1 57.5 197.4 48.5 207.1"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "79.6 197.9 75.8 207.1 92 207.1 79.6 197.9"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "62.9 207.1 75.8 207.1 68.8 197.4 62.9 207.1"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "35.2 330.2 49.8 337.6 51.5 331.7 59.8 340.3 64.7 331.7 69.8 340.2 76.8 332.2 79.1 337.8 92 332 35.2 330.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapBrown);
export default __webpack_public_path__ + "static/media/Shap_Brown.39580213b71ea6b0d18b3ac8d60621d0.svg";
export { ForwardRef as ReactComponent };